import { useLocalization } from "@/data/Localization";
import { StoreDetails } from "@/data/types/Store";
import { getStoreStockAvailabilityText, StockAvailabilityColorCC } from "@/data/utils/StoreStock";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import SquareRoundedIcon from '@mui/icons-material/SquareRounded';
import { storeStockAvailabilitySX } from "../styles/storeDetailsDisplay";

type StoreFeature = {
    storeTimings:string;
    storeClosed:boolean;
    sameDayDelivery:boolean;
    deliveryDay:string;
}

type Props = {
    store: StoreDetails, 
    stock:string,
    storeFeature:StoreFeature|undefined
}

export const StoreStockDetailsDisplay: FC<Props> = ({ store, stock, storeFeature }) => {
    const storeStockNLS = useLocalization('StoreStock');
    const ClickAndCollectNLS = useLocalization("ClickAndCollect");
    const stockAvailabilityText = getStoreStockAvailabilityText(storeStockNLS.CCInvMsg);
    return(
        <>
            <Stack sx={storeStockAvailabilitySX}>
                <SquareRoundedIcon sx={{ color: StockAvailabilityColorCC[stock], fontSize: 16 }} />
                <Typography fontSize={14} fontWeight={700} color={StockAvailabilityColorCC[stock]}>
                    {stockAvailabilityText[stock]}
                </Typography>
            </Stack>
        </>
    );
}